export const auth = {
  LOGIN: '/login',
}
